import React, { useState, useCallback, memo } from "react";
import ProductClassificationSearch from "./ProductClassificationSearch";
import ProductClassificationSelect from "./ProductClassificationSelect";

const ProductClassification = memo(function ProductClassification({
  classificationTree: initialClassificationTree = {},
  productDescription: initialProductDescription = "",
  leafIndex = 0,
  railsFormName = "",
}) {
  const [classificationTree, setClassificationTree] = useState(initialClassificationTree);

  const handleClassificationChange = useCallback((selectedAutoSuggestion) => {
    setClassificationTree((prevTree) => {
      // Deep clone to avoid mutating the previous state
      const updatedClassificationTree = JSON.parse(JSON.stringify(prevTree));

      // Traverse the tree dynamically for any depth
      let currentNode = updatedClassificationTree;
      for (const ancestryId of selectedAutoSuggestion.ancestry_ids) {
        if (!ancestryId || !currentNode) break;
        currentNode.selectedValue = ancestryId;
        currentNode = currentNode.selectOptions?.[ancestryId];
      }

      return updatedClassificationTree;
    });
  }, []);

  return (
    <>
      <ProductClassificationSearch
        value={initialProductDescription}
        handleClassificationChange={handleClassificationChange}
        railsFormName={railsFormName}
      />
      <ProductClassificationSelect
        classificationTree={classificationTree}
        railsFormName={railsFormName}
        leafIndex={leafIndex}
      />
    </>
  );
});

export default ProductClassification;